// ============================================
// MAIN - Application entry point
// ============================================

import { isAuthenticated } from './auth.js';
import { initApp } from './ui.js';
import { initLogin } from './login.js';

document.addEventListener('DOMContentLoaded', () => {
  if (isAuthenticated()) {
    initApp();
  } else {
    initLogin();
  }
});
